// currencies.js

import { ref } from 'vue';

export const currencies = ref([
    { name: 'Euro - EUR', code: 'EUR' },
    { name: 'US Dollar - USD', code: 'USD' },
    { name: 'Australian Dollar - AUD', code: 'AUD' },
    { name: 'Swedish Krona - SEK', code: 'SEK' },
    { name: 'Norwegian Krone - NOK', code: 'NOK' },
    { name: 'Danish Krone - DKK', code: 'DKK' },
    { name: 'British Pound - GBP', code: 'GBP' },
    { name: 'Nigerian Naira - NGN', code: 'NGN' },
    { name: 'Singapore Dollar - SGD', code: 'SGD' },
    { name: 'Polish Zloty - PLN', code: 'PLN' },
    { name: 'Indian Rupee - INR', code: 'INR' },
    { name: 'Bitcoin - BTC', code: 'BTC' },
    { name: 'Russian Ruble - RUB', code: 'RUB' },
    { name: 'Romanian Leu - RON', code: 'RON' },
    { name: 'Mexican Peso - MXN', code: 'MXN' },
    { name: 'Colombian Peso - COP', code: 'COP' },
    { name: 'Canadian Dollar - CAD', code: 'CAD' },
    { name: 'Ukrainian Hryvnia - UAH', code: 'UAH' },
    { name: 'New Zealand Dollar - NZD', code: 'NZD' },
    { name: 'Thai Baht - THB', code: 'THB' },
    { name: 'Chilean Peso - CLP', code: 'CLP' },
    { name: 'Bulgarian Lev - BGN', code: 'BGN' },
    { name: 'South African Rand - ZAR', code: 'ZAR' },
    { name: 'Tunisian Dinar - TND', code: 'TND' },
    { name: 'Ethereum - ETH', code: 'ETH' },
    { name: 'Japanese Yen - JPY', code: 'JPY' },
    { name: 'Brazilian Real - BRL', code: 'BRL' },
    { name: 'South Korean Won - KRW', code: 'KRW' },
    { name: 'Peruvian Sol - PEN', code: 'PEN' },
    { name: 'MilliBitcoin - mBTC', code: 'mBTC' },
    { name: 'Chinese Yuan - CNY', code: 'CNY' },
    { name: 'Czech Koruna - CZK', code: 'CZK' },
    { name: 'Argentine Peso - ARS', code: 'ARS' },
    { name: 'Kenyan Shilling - KES', code: 'KES' },
    { name: 'Turkish Lira - TRY', code: 'TRY' },
    { name: 'Swiss Franc - CHF', code: 'CHF' },
]);

export function formatCurrency(value) {
    if (typeof value !== 'number') return value;
    
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Math.round(value));
}
export function formatCurrencyWithCents(value) {
  if (typeof value !== 'number') return value;
  
  return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
  }).format(value);
}

export function formatCurrencyWithK(value) {
  if (value === null || value === undefined) return '€0';
  
  // If less than 1000, format normally
  if (value < 1000) {
    return `€${value.toFixed(0)}`;
  }
  
  // For 1000 or more, format with K
  const valueInK = (value / 1000).toFixed(1);
  // Remove .0 if it's a whole number
  const formattedK = valueInK.endsWith('.0') ? valueInK.slice(0, -2) : valueInK;
  return `€${formattedK}K`;
}

